import { render } from "./PayFooter.vue?vue&type=template&id=6c5fb11d"
import script from "./PayFooter.vue?vue&type=script&lang=js"
export * from "./PayFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__